import { useForm } from "react-hook-form";
import axios from "axios";
const AddressForm = ({ setRewardsList, setLoading, bnbPrice }) => {
  const { register, handleSubmit, formState } = useForm();

  const { errors, isSubmitting } = formState;

  const API_TOKEN = "8MCEKAVQVG4CB5G6YJWGMMABPMJ7JG6WIV";

  const isToday = (timestamp) => {
    const currentDate = new Date();
    const inputDate = new Date(parseInt(timestamp) * 1000);
    return (
      currentDate.getDate() === inputDate.getDate() &&
      currentDate.getMonth() === inputDate.getMonth() &&
      currentDate.getFullYear() === inputDate.getFullYear()
    );
  };

  const weiToBnb = (wei) => {
    return parseFloat(wei) / 1000000000 / 1000000000;
  };

  const bnbToUsd = (bnb) => {
    return parseFloat(bnb * bnbPrice.usd).toFixed(2);
  };

  const bnbToEur = (bnb) => {
    return parseFloat(bnb * bnbPrice.eur).toFixed(2);
  };

  const getRewards = async (address) => {
    try {
      const internalTxns = await axios.get(
        `https://api.bscscan.com/api?module=account&action=txlistinternal&address=${address}&sort=desc&apikey=${API_TOKEN}`
      );
      const zcoinTxns = internalTxns.data.result.filter(
        (txn) =>
          txn.from === "0x2eec402f71af966f4cc9bd69703abe0a04cea470" &&
          txn.isError === "0"
      );

      const simplifiedTxns = [];

      let totalGainBNB = 0;
      let todayGainBNB = 0;

      for (const txn of zcoinTxns) {
        const value = txn.value;
        const bnbValue = weiToBnb(value);

        totalGainBNB += bnbValue;
        if (isToday(txn.timeStamp)) {
          todayGainBNB += bnbValue;
        }

        simplifiedTxns.push({
          timestamp: txn.timeStamp,
          value: {
            bnb: bnbValue,
            usd: bnbToUsd(bnbValue),
            eur: bnbToEur(bnbValue),
          },
        });
      }
      const rewardsList = {
        total: {
          bnb: totalGainBNB,
          usd: bnbToUsd(totalGainBNB),
          eur: bnbToEur(totalGainBNB),
        },
        today: {
          bnb: totalGainBNB,
          usd: bnbToUsd(todayGainBNB),
          eur: bnbToEur(todayGainBNB),
        },
        detailedTxns: simplifiedTxns,
      };

      return rewardsList;
    } catch (err) {
      return err.message;
    }
  };

  const onSubmit = async ({ address }) => {
    setLoading(true);
    setRewardsList(await getRewards(address.trim()));
    setLoading(false);
  };

  const styles = {
    disabled: {
      backgroundColor: "gray",
    },
  };
  return (
    <section className="sectionForm">
      <div className="formContainer">
        <h2 className="formTitle">Check your rewards!</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="wrapInput">
            <input
              className="addressInput"
              autoComplete="off"
              spellCheck="false"
              placeholder=" "
              type="text"
              id="address"
              {...register("address", {
                required: "You need to input a valid address.",
                pattern: {
                  value: /\s*0[xX][0-9a-fA-F]{40}\s*/g,
                  message: "You need to input a valid address.",
                },
              })}
            />
            <label className="inputLabel" name="address">
              Enter your address here
            </label>
            {errors.address ? (
              <span className="errorSpan">{errors.address.message}</span>
            ) : (
              <span className="errorSpan"> </span>
            )}
          </div>

          <button
            style={isSubmitting ? styles.disabled : null}
            className="submitAddressBtn"
            disabled={isSubmitting}
            type="submit"
          >
            Check my rewards!
          </button>
        </form>
      </div>
    </section>
  );
};

export { AddressForm };
